import { FC } from 'react';
import { SvgProps } from './domain';

const Locker: FC<SvgProps> = ({ className }) => (
  <svg
    className={className}
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.875 6.25H12.5C12.8452 6.25 13.125 6.52981 13.125 6.875V13.125C13.125 13.4702 12.8452 13.75 12.5 13.75H2.5C2.15483 13.75 1.875 13.4702 1.875 13.125V6.875C1.875 6.52981 2.15483 6.25 2.5 6.25H3.125V5.625C3.125 3.20876 5.08376 1.25 7.5 1.25C9.91625 1.25 11.875 3.20876 11.875 5.625V6.25ZM3.125 7.5V12.5H11.875V7.5H3.125ZM6.875 8.75H8.125V11.25H6.875V8.75ZM10.625 6.25V5.625C10.625 3.89911 9.22587 2.5 7.5 2.5C5.77411 2.5 4.375 3.89911 4.375 5.625V6.25H10.625Z'
      fill='url(#paint0_linear_1261_348)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1261_348'
        x1='7.5'
        y1='1.25'
        x2='7.5'
        y2='13.75'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#00D2A4' />
        <stop offset='1' stopColor='#006FFF' />
      </linearGradient>
    </defs>
  </svg>
);

export default Locker;
